export default "__VITE_ASSET__BZ6x3SMw__"